// src/components/Product/AccessGate.js
import React, { useState } from 'react';
import MediaFileList from './MediaFileList'; 
import { ShoppingCart } from 'lucide-react'; 

const AccessGate = ({ 
    hasAccess, 
    isFree, 
    mediaFiles, 
    productSlug, 
    protectedUrlPath,
    onBuyClick,            // تابع خرید از والد
    priceDisplay           // (اختیاری) نمایش قیمت
}) => {
    
    const [isPurchasing, setIsPurchasing] = useState(false); 

    const handlePurchase = async () => {
        // ✅ بررسی دقیق اینکه onBuyClick یک تابع است
        if (typeof onBuyClick !== 'function') {
            console.error('❌ AccessGate: onBuyClick is not a function', onBuyClick);
            return;
        }
        setIsPurchasing(true);
        try {
            await onBuyClick();
        } catch (error) {
            console.error("Purchase failed:", error);
        } finally {
            setIsPurchasing(false);
        }
    };

    // حالت دسترسی کامل (رایگان یا خریداری شده)
    if (hasAccess || isFree) {
        if (mediaFiles && mediaFiles.length > 0) {
            return (
                <div className="content-access-granted">
                    <MediaFileList 
                        mediaFiles={mediaFiles} 
                        protectedUrlPath={protectedUrlPath}
                    />
                </div>
            );
        }
        return null;
    }

    // حالت نیاز به خرید (دکمه خرید)
    return (
        <div className="content-access-denied text-center">
            <button 
                className={`
                    font-bold text-[11px] p-2 rounded-lg w-full
                    flex items-center justify-center 
                    transition duration-150 ease-in-out
                    ${isPurchasing 
                        ? 'bg-green-600 hover:bg-green-700 cursor-not-allowed opacity-90 text-white'
                        : 'border-[3px] border-[#5730E3] bg-white text-[#5730E3] hover:bg-indigo-50'}
                `}
                onClick={handlePurchase}
                disabled={isPurchasing}
            >
                <ShoppingCart 
                    size={18} 
                    className={`ml-2 ${isPurchasing ? 'text-white' : 'text-[#5730E3]'}`} 
                />
                {isPurchasing ? 'درحال اتصال به درگاه...' : 'خرید درس‌گفتار'}
            </button>
            {priceDisplay && (
                <div className="text-gray-500 text-xs mt-2">{priceDisplay}</div>
            )}
        </div>
    );
};

export default AccessGate;